<template>
  <div class="full-width">
    <section class="mb-4 pt-3">
      <div class="container">
        <div class="bg-white shadow-sm rounded p-3">
          <div class="row">
            <div class="col-xl-5 col-lg-6 mb-4">
              <div class="sticky-top z-3 row gutters-10">
                <div class="col">
                  <div
                      class="aiz-carousel product-gallery slick-initialized slick-slider"
                  >
                    <div
                        class="carousel-box img-zoom rounded"
                        style="width: 100%; display: inline-block"
                    >
                      <img
                          v-if="goodsPics.length"
                          :src="getFileViewUrl(bigImg)"
                          alt
                          class="img-fluid ls-is-cached lazyloaded"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-3">
                  <div
                      class="aiz-carousel product-gallery-thumb slick-initialized slick-slider half-outside-arrow"
                      data-vertical="true"
                  >
                    <button
                        v-if="goodsPics.length > itemCount"
                        class="slick-prev slick-arrow slick-disabled"
                        type="button"
                        @click="prev"
                    >
                      <i class="las la-angle-left"></i>
                    </button>
                    <van-swipe
                        ref="swipe"
                        :autoplay="999999999"
                        :loop="false"
                        :show-indicators="false"
                        :width="itemWidth"
                    >
                      <van-swipe-item
                          v-for="(pic, index) in goodsPics"
                          :key="index"
                      >
                        <div
                            v-if="pic"
                            :class="{ 'slick-current': index === selected }"
                            :style="{
                            width: `${itemWidth}px`,
                            height: `${itemWidth}px`
                          }"
                            class="slick-slide slick-active"
                            @click="onClickItem(index)"
                            @mouseenter="onClickItem(index)"
                        >
                          <div
                              class="carousel-box c-pointer border p-1 rounded"
                          >
                            <!--                            + '_tn'"-->
                            <img
                                :src="getFileViewUrl(pic)"
                                alt
                                class="mw-100 mh-100"
                            />
                          </div>
                        </div>
                      </van-swipe-item>
                    </van-swipe>
                    <button
                        v-if="goodsPics.length > itemCount"
                        class="slick-next slick-arrow"
                        type="button"
                        @click="next"
                    >
                      <i class="las la-angle-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-7 col-lg-6">
              <div class="text-left">
                <h1 class="mb-2 fs-20 fw-600">
                  {{ $t(goods.name) }}
                </h1>

                <div class="row align-items-center"
                     v-if="'C06'!==paramMapAll['SYSTEM_VERSION'] && 'B10'!==paramMapAll['SYSTEM_VERSION']">
                  <div class="col-12">
                    <span class="rating">
                      <i
                          v-for="index of 5"
                          :key="index"
                          :class="{ active: index <= goods.stars }"
                          class="las la-star"
                      ></i>
                    </span>
                    <span class="ml-1 opacity-50"
                    >({{ commentNumber }} {{ $t("评论") }})</span
                    >
                  </div>
                  <div class="col-12">
                    <small class="mr-2 opacity-50">{{ $t("类别") }}</small>
                    <span
                        @click="jump(`/category?cateName=${encodeURIComponent($t(goods.goodsCateName))}&cateCode=${goods.goodsCateCode}`)">{{
                        $t(goods.goodsCateName)
                      }}</span>
                  </div>
                  <div class="col-auto ml">
                    <small class="mr-2 opacity-50"
                    >{{ $t("估计运输时间") }}:</small
                    >{{ `3 ${$t("天")}` }}
                  </div>
                </div>
                <!--                <hr/>-->
                <!--                <hr/>-->

                <div class="row align-items-center">
                  <div class="col-auto">
                    <small class="mr-2 opacity-50">{{ $t("所售") }}:</small><br/>
                    <router-link :to="shopUrl" class="text-reset">{{ userShop.name }}</router-link>
                  </div>
                  <div class="col-auto">
                    <!--                    CHAT_OPEN("全局聊天功能暂未开放"),-->
                    <button v-if="'1'===paramMapAll['CHAT_OPEN']"
                            class="btn btn-sm btn-soft-primary"
                            @click="showChatModal"
                    >
                      {{ $t("给商家留言") }}
                    </button>
                  </div>

                  <div class="col-auto">
                    <router-link :to="shopUrl">
                      <img
                          :src="getFileViewUrl(userShop.imgHead)"
                          alt=""
                          height="30"
                      />
                    </router-link>
                  </div>
                </div>

                <hr/>

                <div class="row no-gutters mt-3">
                  <div class="col-sm-2">
                    <div class="opacity-50 my-2">{{ $t("价格") }}:</div>
                  </div>
                  <div class="col-sm-10">
                    <div class="">
                      <strong class="h2 fw-600 text-primary">
                        {{ showPrice }}
                      </strong>
                      <span v-if="oriPrice" class="h4 opacity-50" style="text-decoration: line-through;">
                        {{ oriPrice }}
                      </span>
                      <!--                      <span class="opacity-70">/Pc</span>-->
                    </div>
                  </div>
                </div>

                <hr/>

                <template v-if="goods.specs && hasMulSpec(goods.specs)">
                  <GoodsSpecSelects
                      :goods="goods"
                      :show-select-spec="showSelectSpec"
                      @hover="onHoverOption"
                      @select="onSelectSpec"
                  />
                </template>

                <!-- Quantity + Add to cart -->
                <div class="row no-gutters">
                  <div class="col-sm-2">
                    <div class="opacity-50 my-2">{{ $t("数量") }}:</div>
                  </div>
                  <div class="col-sm-10">
                    <div class="product-quantity d-flex align-items-center">
                      <div
                          class="row no-gutters align-items-center aiz-plus-minus mr-3"
                          style="width: 130px"
                      >
                        <button
                            class="btn col-auto btn-icon btn-sm btn-circle btn-light"
                            type="button"
                            @click="quantity > 1 && quantity--"
                        >
                          <i class="las la-minus"></i>
                        </button>
                        <input
                            v-model="quantity"
                            class="col border-0 text-center flex-grow-1 fs-16 input-number"
                            lang="en"
                            max="999"
                            min="1"
                            name="quantity"
                            placeholder="1"
                            type="number"
                            value="1"
                        />
                        <button
                            class="btn col-auto btn-icon btn-sm btn-circle btn-light"
                            type="button"
                            @click="quantity++"
                        >
                          <i class="las la-plus"></i>
                        </button>
                      </div>
                      <div v-if="goods.stock >= 0" class="avialable-amount opacity-60">
                        (<span id="available-quantity">{{ goods.stock }}</span>
                        {{ $t("库存") }})
                      </div>
                    </div>
                  </div>
                </div>

                <hr/>

                <div
                    v-if="specId"
                    id="chosen_price_div"
                    class="row no-gutters pb-3"
                >
                  <div class="col-sm-2">
                    <div class="opacity-50 my-2">{{ $t("总价") }}:</div>
                  </div>
                  <div class="col-sm-10">
                    <div class="product-price">
                      <strong
                          id="chosen_price"
                          class="h4 fw-600 text-primary"
                      >{{ formatMoney(priceDiscount(spec.price) * quantity) }}</strong>
                      <span v-if="oriPrice" class="h6 opacity-50 ml-2" style="text-decoration: line-through;">
                        {{ oriPrice * quantity }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="mt-3">
                  <button
                      class="btn btn-soft-primary mr-2 add-to-cart fw-600"
                      type="button"
                      @click="addToCart"
                  >
                    <i class="las la-shopping-bag"></i>
                    <span class="d-none d-md-inline-block">
                      {{ $t("添加到购物车") }}</span
                    >
                  </button>
                  <button
                      class="btn btn-primary buy-now fw-600"
                      type="button"
                      @click="buyNow"
                  >
                    <i class="la la-shopping-cart"></i> {{ $t("立即购买") }}
                  </button>
                  <button
                      class="btn btn-secondary out-of-stock fw-600 d-none"
                      disabled=""
                      type="button"
                  >
                    <i class="la la-cart-arrow-down"></i> {{ $t("缺货") }}
                  </button>
                </div>

                <div class="d-table width-100 mt-3">
                  <div class="d-table-cell">
                    <!-- Add to wishlist button -->
                    <button
                        class="btn pl-0 btn-link fw-600"
                        type="button"
                        @click="addToWishList()"
                    >
                      {{ $t("添加到愿望清单") }}
                    </button>
                    <!-- Add to compare button -->
                    <button
                        class="btn btn-link btn-icon-left fw-600"
                        type="button"
                        @click="addToCompare()"
                    >
                      {{ $t("加入对比列表") }}
                    </button>
                  </div>
                </div>

                <div class="row no-gutters mt-3">
                  <div class="col-2">
                    <div class="opacity-50 mt-2">{{ $t("退款") }}:</div>
                  </div>
                  <div class="col-10">
                    <router-link :to="`/terms?code=${ARTICLE_RETURN_ID()}`">
                      <img
                          alt
                          height="36"
                          src="/static/assets/img/refund-sticker.jpeg"
                      />
                    </router-link>
                    <router-link
                        :to="`/terms?code=${ARTICLE_RETURN_ID()}`"
                        class="ml-2"
                    >{{ $t("查看条款") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-4">
      <div class="container">
        <div class="row gutters-10">
          <div class="col-xl-3 order-1 order-xl-0">
            <div class="bg-white shadow-sm mb-3">
              <div class="position-relative p-3 text-left">
                <div class="absolute-top-right p-2 bg-white z-1">
                  <svg
                      height="34"
                      viewBox="0 0 287.5 442.2"
                      width="22"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polygon
                        points="223.4,442.2 143.8,376.7 64.1,442.2 64.1,215.3 223.4,215.3 "
                        style="fill: #f8b517"
                    ></polygon>
                    <circle
                        cx="143.8"
                        cy="143.8"
                        r="143.8"
                        style="fill: #fbd303"
                    ></circle>
                    <circle
                        cx="143.8"
                        cy="143.8"
                        r="93.6"
                        style="fill: #f8b517"
                    ></circle>
                    <polygon
                        points="143.8,55.9 163.4,116.6 227.5,116.6 175.6,154.3 195.6,215.3 143.8,177.7 91.9,215.3 111.9,154.3
                                            60,116.6 124.1,116.6 "
                        style="fill: #fcfcfd"
                    ></polygon>
                  </svg>
                </div>
                <div class="opacity-50 fs-12 border-bottom">
                  {{ $t("所售") }}
                </div>
                <router-link :to="shopUrl" class="text-reset d-block fw-600">
                  {{ userShop.name }}
                  <span class="ml-2"><i class="fa fa-check-circle" style="color: green"></i></span>
                </router-link>
                <div class="location opacity-70">{{ userShop.contact }}</div>
                <div class="text-center border rounded p-2 mt-3"
                     v-if="'C06'!==paramMapAll['SYSTEM_VERSION'] && 'B10'!==paramMapAll['SYSTEM_VERSION']">
                  <div class="rating">
                    <StarsComp :star="userShop.starts"/>
                  </div>
                  <div class="opacity-60 fs-12">(0 {{ $t("客户评论") }})</div>
                </div>
              </div>
              <div class="row no-gutters align-items-center border-top">
                <div class="col">
                  <router-link
                      :to="shopUrl"
                      class="d-block btn btn-soft-primary rounded-0"
                  >{{ $t("访问商店") }}
                  </router-link>
                </div>
                <div class="col">
                  <ul class="social list-inline mb-0">
                    <li class="list-inline-item mr-0">
                      <router-link class="facebook" to="/">
                        <i class="lab la-facebook-f opacity-60"></i>
                      </router-link>
                    </li>
                    <li class="list-inline-item mr-0">
                      <router-link class="google" to="/">
                        <i class="lab la-google opacity-60"></i>
                      </router-link>
                    </li>
                    <li class="list-inline-item mr-0">
                      <router-link class="twitter" to="/">
                        <i class="lab la-twitter opacity-60"></i>
                      </router-link>
                    </li>
                    <li class="list-inline-item">
                      <router-link class="youtube" to="/">
                        <i class="lab la-youtube opacity-60"></i>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="bg-white rounded shadow-sm mb-3">
              <div class="p-3 border-bottom fs-16 fw-600">
                {{ $t("畅销产品") }}
              </div>
              <div class="p-3">
                <ul class="list-group list-group-flush">
                  <li
                      v-for="item in goodsListMost"
                      :key="item.id"
                      class="py-3 px-0 list-group-item border-light"
                      @click="
                      jump(`/product?goodsId=${item.id}&shopId=${item.shopId}`)
                    "
                  >
                    <div class="row gutters-10 align-items-center">
                      <div class="col-5">
                        <a class="d-block text-reset">
                          <img
                              :src="getFileViewUrl(item.pic)"
                              alt=""
                              class="img-fit lazyload h-xxl-110px h-xl-80px h-120px"
                          />
                        </a>
                      </div>
                      <div class="col-7 text-left">
                        <h4 class="fs-13 text-truncate-2">
                          <a class="d-block text-reset">{{ item.name }} </a>
                        </h4>
                        <StarsComp :star="item.stars"/>
                        <div class="mt-2">
                          <span class="fs-17 fw-600 text-primary">{{
                              formatMoney(item.price)
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-9 order-0 order-xl-1">
            <div class="bg-white mb-3 shadow-sm rounded">
              <div class="nav border-bottom aiz-nav-tabs">
                <a
                    :class="{ active: !showReviews, show: !showReviews }"
                    class="p-3 fs-16 fw-600 text-reset"
                    @click="showReviews = false"
                >{{ $t("描述") }}</a
                >
                <a v-if="'B10'!==paramMapAll['SYSTEM_VERSION']"
                   :class="{ active: showReviews, show: showReviews }"
                   class="p-3 fs-16 fw-600 text-reset"
                   @click="showReviews = true"
                >{{ $t("评论") }} ({{ commentNumber }})</a
                >
              </div>

              <div class="tab-content pt-0">
                <div
                    id="tab_default_1"
                    :class="{ active: !showReviews, show: !showReviews }"
                    class="tab-pane fade"
                >
                  <div class="p-4">
                    <div
                        class="mw-100 overflow-hidden text-left aiz-editor-data"
                    >
                      <div class="f7AU53" v-html="goods.description"></div>
                    </div>
                  </div>
                </div>
                <div
                    id="tab_default_4"
                    :class="{ active: showReviews, show: showReviews }"
                    class="tab-pane fade"
                >
                  <div class="p-4">
                    <ul
                        class="list-group list-group-flush"
                        v-if="goodsEvaluationList.length"
                    >
                      <li
                          class="media list-group-item d-flex"
                          v-for="(item, index) in goodsEvaluationList"
                          :key="index"
                      >
                        <span class="avatar avatar-md mr-3">
                          <img
                              class=" ls-is-cached lazyloaded"
                              :src="getFileViewUrl(item.photo)"
                          />
                        </span>
                        <div class="media-body text-left">
                          <div class="d-flex justify-content-between">
                            <h3 class="fs-15 fw-600 mb-0">{{ $t("匿名") }}</h3>
                            <StarsComp :star="item.rating"/>
                          </div>
                          <p class="comment-text">
                            {{ item.content }}
                          </p>
                        </div>
                      </li>
                    </ul>

                    <div class="text-center fs-18 opacity-70" v-else>
                      {{ $t("该产品暂无评论") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-white rounded shadow-sm">
              <div class="border-bottom p-3">
                <h3 class="fs-16 fw-600 mb-0">
                  <span class="mr-4">{{ $t("相关产品") }}</span>
                </h3>
              </div>
              <div class="p-3">
                <ProductsSlide :list="goodsListCateCode"/>
              </div>
            </div>
            <div class="bg-white rounded shadow-sm mt-3">
              <div class="border-bottom p-3">
                <h3 class="fs-18 fw-600 mb-0">
                  <span>{{ $t("产品查询") }} (0)</span>
                </h3>
              </div>
              <div class="pagination-area my-4 mb-0 ml-3">
                <p>{{ $t("没有人问过商家") }}</p>
                <div class="aiz-pagination py-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ProductQueryModal ref="productQueryModal"/>
  </div>
</template>
<script>
import StarsComp from "@/components/StarsComp.vue";
import {getDetail} from "@/api/goods";
import {DeviceUtil} from "@/utils/deviceUtil";
import ProductsSlide from "@/components/ProductsSlide.vue";
import GoodsSpecSelects from "@/components/GoodsSpecSelects.vue";
import {ARTICLE_RETURN_ID} from "@/constant/constant";
import ProductQueryModal from "@/components/ProductQueryModal.vue";

export default {
  name: "ProductDetail",
  components: {ProductQueryModal, ProductsSlide, StarsComp, GoodsSpecSelects},
  data() {
    const itemWidth = DeviceUtil.isMobile() ? 63 : 90;
    const itemCount = DeviceUtil.isMobile() ? 5 : 6;
    return {
      quantity: 1,
      showReviews: false,

      productId: 0,

      itemWidth,
      itemCount,
      selected: 0,
      bigImg: "",

      goodsId: null,
      shopId: null,
      goods: {},
      goodsListCateCode: [],
      userShop: {},
      specId: null,
      goodsListMost: [],
      goodsEvaluationList: [],
      // goodsEvaluationTotal: 0,
      commentNumber: 0,
      params: {},
      randomMulti: parseInt(Math.random() * new Date().getTime()),
      showSelectSpec: false
    };
  },
  computed: {
    // 合并数组 示例用法
    // const array1 = [1, 2, 3];
    // const array2 = [10, 20, 30, 40, 50];
    //
    // const result = mergeArrays(array1, array2);
    // console.log(result); // 输出 [10, 20, 30, 4, 5
    shopUrl() {
      return `/shop?shopId=${this.shopId}`;
    },
    goodsPics() {
      if (this.goods) {
        return this.mergeArrays(this.splitStr(this.goods.pics), this.splitStr(this.goods.picTns)).filter(pic => pic)
      }
      return []
    },
    oriPrice() {
      let buyDiscount = this.goods.buyDiscount || 100;
      if (100 === buyDiscount) {
        return ''
      } else {
        return this.goods.price
      }
    },
    showPrice() {
      if (!this.goods.specs) {
        return "-";
      }
      if (this.specId) {
        let spec = this.goods.specs.find(spec => spec.id === this.specId);
        const price = spec && spec.price;
        return this.formatMoney(this.priceDiscount(price));
      } else {
        let min;
        let max;
        for (const spec of this.goods.specs) {
          if (min === undefined || spec.price < min) {
            min = spec.price;
          }
          if (max === undefined || spec.price > max) {
            max = spec.price;
          }
        }

        if (min === max) {
          return this.formatMoney(min);
        } else {
          return `${this.formatMoney(this.priceDiscount(min))} - ${this.formatMoney(this.priceDiscount(max))}`;
        }
      }
    },
    spec() {
      const specs = this.goods.specs;
      if (specs) {
        return specs.find(spec => spec.id === this.specId) || specs[0];
      } else {
        return undefined;
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.requestData();
      },
      immediate: true
    }
  },
  async created() {
    await this.requestData();
    if (this.$route.query.isChat) {
      this.$nextTick(() => {
        this.$refs.productQueryModal.show(this.goods, this.userShop.userId);
      })
    }
  },
  activated() {
    this.requestData();
  },
  methods: {
    priceDiscount(price) {
      if (!this.userShop || !this.userShop.isSeckillShop) return price
      let buyDiscount = this.goods.buyDiscount || 100;
      return price * buyDiscount / 100
    },
    splitStr(strs) {
      if (strs) {
        return strs.split(',')
      } else {
        return []
      }
    },
    mergeArrays(array1, array2) {
      const maxLength = Math.max(array1.length, array2.length);
      const mergedArray = [];

      for (let i = 0; i < maxLength; i++) {
        const value1 = i < array1.length ? array1[i] : null;
        const value2 = i < array2.length ? array2[i] : null;

        mergedArray.push(value2 !== null ? value2 : value1);
      }

      return mergedArray;
    },
    ARTICLE_RETURN_ID() {
      return ARTICLE_RETURN_ID;
    },
    onClickItem(index) {
      this.selected = index;
      this.bigImg = this.goodsPics[index];
    },
    onSelectSpec(spec) {
      if (spec) {
        this.specId = spec.id;
        this.showSpecPic(spec);
        this.showSelectSpec = false;
      } else {
        this.specId = undefined;
        this.onClickItem(this.selected);
      }
    },
    onHoverOption(pic) {
      this.bigImg = pic;
    },
    showSpecPic(spec) {
      if (spec.pic) {
        this.bigImg = spec.pic;
      }
    },
    prev() {
      this.$refs.swipe.prev();
    },
    next() {
      this.$refs.swipe.next();
    },
    addToWishList() {
      this.$store
          .dispatch("user/addToWishList", {
            goodsId: this.goods.id,
            goodsSpecId: this.specId,
            number: 1,
            shopId: this.shopId
          })
          .then(() => {
            this.$toast.success(this.$t("物品已添加到愿望清单"));
          });
    },
    addToCompare() {
      this.$store
          .dispatch("user/addToCompareList", {
            goodsId: this.goods.id,
            goodsSpecId: this.specId,
            number: 1,
            shopId: this.shopId
          })
          .then(() => {
            this.$toast.success(this.$t("物品已添加到比较列表"));
          });
    },
    checkSpec() {
      if (this.specId) {
        return true;
      }
      this.showSelectSpec = true;
    },
    addToCart() {
      if (!this.checkSpec()) return;
      this.$store
          .dispatch("user/addToCart", {
            shopId: this.shopId,
            goodsSpecId: this.specId,
            goodsId: this.goods.id,
            number: this.quantity
          })
          .then(() => {
            this.showItemAddedToCartDialog(this.spec, this.goods.cateCode, this.goods);
          });
    },
    buyNow() {
      if (!this.checkSpec()) return;
      let data = {
        shopId: this.shopId,
        goodsSpecId: this.specId,
        goodsId: this.goods.id,
        number: this.quantity
      };
      if (this.paramMapAll['SHOP_GOODS_ORDER_NEED_ADDRESS'] === '1') {
        this.$store
            .dispatch("user/addToCart", data)
            .then(() => {
              this.$router.push("/user/cart");

            });
      } else {
        // 直接下单
        Cookies.set('buyNowData', encodeURIComponent(JSON.stringify([data])))
        this.$router.push("/user/checkout/payment_select?needAddress=&buyNow=1");
      }
    },
    showChatModal() {
      this.$refs.productQueryModal.show(this.goods, this.userShop.userId);
    },
    async getGoodsDetail(shopId, goodsId) {
      const res = await getDetail(shopId, goodsId);
      this.goods = res.data;
      if (!this.hasMulSpec(this.goods.specs)) {
        this.specId = this.goods.specs[0].id;
      }
    },
    async getUserShop(userShopId) {
      this.userShop = userShopId
          ? (await this.$get(`userShop/getById/${userShopId}`)).data
          : {};
    },
    async pageGoodsCateCode() {
      const params = {
        goodsCateCode: this.goods.cateCode,
        randomMulti: this.randomMulti
      };
      const page = (await this.$get("/goods/page", {params})).data;
      this.goodsListCateCode = page.records;
    },
    async pageGoodsMost() {
      // this.params.shopId = this.shopId;
      this.params["orders"] = [
        {column: "`storeGoods.sales`", asc: false},
        {column: "`storeGoods.id`", asc: false}
      ];
      let page = (
          await this.$get("/goods/page", {
            params: this.params,
            randomMulti: this.randomMulti
          })
      ).data;
      this.goodsListMost = page.records.slice(0, 6);
      // this.goodsListMost = this.goodsListMost.concat(page.records).slice(0, 6);
    },
    async pageGoodsEvaluation() {
      const res = await this.$get("/goodsEvaluation/page", {
        params: {
          curPage: 1,
          goodsId: this.goodsId,
          shopUserId: this.userShop.userId
        },
        randomMulti: this.randomMulti
      });
      this.goodsEvaluationList = res.data.records;
      this.commentNumber = res.data.total;
    },
    async requestData() {
      if (this.$route.query.goodsId) {
        this.goodsId = this.$route.query.goodsId;
      }
      if (this.$route.query.shopId) {
        this.shopId = this.$route.query.shopId;
        await this.getUserShop(this.shopId);
      }
      await this.getGoodsDetail(this.shopId, this.goodsId)
      this.pageGoodsCateCode();
      this.pageGoodsMost();
      this.pageGoodsEvaluation();
      this.onClickItem(0);
    },
    hasMulSpec(specs) {
      return specs.length && this.isValidateSpec(specs[0].name);
    }
  }
};
</script>
<style scoped>
.MCCLkq {
  margin: 1.875rem 0.9375rem 0.9375rem;
}

.f7AU53 {
  white-space: pre-wrap;
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.7;
}

.irIKAp {
  margin: 0;
}

.irIKAp img {
  pointer-events: none;
}

.cxDtMn img {
  vertical-align: bottom;
}

._0O7Vlf {
  height: 100%;
  width: 100%;
  object-fit: fill !important;
}

.bgImIg {
  opacity: 1;
  transition: opacity 0.2s ease;
}

.cxDtMn {
  position: relative;
}
</style>
